import merchantGatewayApi from 'apis/merchant-gateway/api';

const REPORT_YEAR = '2023';

export const getDac7DownloadLink = async (merchantId: string, year: string = REPORT_YEAR): Promise<string | null> => {
  const {
    data: { isEligible },
  } = await merchantGatewayApi.get<{
    isEligible: boolean;
  }>(`/merchant-analytics-api/v1/dac_7/merchants/${merchantId}/is_eligible`);

  if (!isEligible) {
    return null;
  }

  const {
    data: { downloadLink },
  } = await merchantGatewayApi.get<{ downloadLink: string }>(
    `/merchant-analytics-api/v1/dac_7/merchants/${merchantId}/${year}/download_link`,
  );

  return downloadLink;
};
